module.exports = __webpack_public_path__ + "img/itx-text-italic.5caba36e.svg";